import(/* webpackMode: "eager" */ "/app/src/modules/pricing/components/views/PricingView.tsx")